export const ADVANCEMENT_CUTSCENE_DURATION: number = 8_000;
